import { defineQueryKeys } from '@/shared/lib/queryKeys';

export const scenarioKeys = defineQueryKeys('scenarios', (all) => ({
  list: (teamId?: string) => [...all, 'list', teamId] as const,
  /** 팀 구분 없는 목록 전체 — 무효화 전용 접두사. 타임라인 기록이 붙으면 서류 목록의 기록 건수·정지 표기가 바뀐다. */
  listAll: [...all, 'list'] as const,
  detail: (id: string) => [...all, 'detail', id] as const,
  reference: (id: string) => [...all, 'reference', id] as const,
  /**
   * 본인 작성 중 초안 (임시저장). plan 2026-08-14T04-51-41Z-a3f21c7d T2-4.
   *
   * ⚠ 자동저장은 이 키만 무효화해야 한다. `scenarioKeys.all`(=['scenarios'])을 무효화하면
   * list 키가 그 접두사 안이라 함께 refetch → 그리드 재렌더 → 부모가 새 ownerTeam 객체를 만들고
   * → 복원 effect 가 재실행돼 **자동저장이 스스로 폼을 리셋시킨다**. 2초마다.
   */
  myDraft: () => [...all, 'my-draft'] as const,
  /** 섭외 체크인 계약 잔여 요약 — detail 과 별개 경량 조회라 키도 따로 둔다. */
  recruitRemaining: (id: string) => [...all, 'recruit-remaining', id] as const,
  /**
   * 붙어 있는 설문폼의 지금 상태 (퀘스트 8042eca6 CP4).
   *
   * detail 에 얹지 않은 값이라 키도 따로 둔다 — 계약 확인이 구글 왕복이어서, 상세를 여는
   * 모든 화면이 그 값을 쓰지도 않으면서 비용을 내게 된다. 팝오버를 열 때만 켜진다.
   */
  outreachFormStatus: (id: string) => [...all, 'outreach-form-status', id] as const,
  outreachFormWatch: (id: string) => [...all, 'outreach-form-watch', id] as const,
}));
